module.exports = __webpack_public_path__ + "static/media/etienne-cv-fr.3d762c58.pdf";